import React from "react";
import { createRoot } from "react-dom/client";
import ResizeObserverPolyfill from "resize-observer-polyfill";

import '@utilitywarehouse/hearth-fonts';
import '@utilitywarehouse/hearth-react/styles.css';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Some Safari/WebKit versions lack ResizeObserver, which react-datepicker
// (used internally by hearth-react's DatePicker) relies on and throws on if missing.
if (typeof window.ResizeObserver === "undefined") {
  window.ResizeObserver = ResizeObserverPolyfill;
}

declare global {
  interface Window {
    REACT_APP_GRAPHQL_ENDPOINT: string;
    REACT_APP_SENTRY_DSN: string;
    REACT_APP_SENTRY_ENV: string;
  }
}

const root = createRoot(document.getElementById("root")!)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
